module.exports = __webpack_public_path__ + "img/10.6ad7a4a5.png";